var _a;
import { getAllActions } from "../generic/all.actions";
import CONFIG from "./invoiceItem.config";
export var getDetail = (_a = getAllActions({
    entityName: CONFIG.ENTITY_NAME,
}), _a.getDetail), getPaged = _a.getPaged;
